import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=72bf0def&scoped=true"
import script from "./productItem.vue?vue&type=script&lang=js"
export * from "./productItem.vue?vue&type=script&lang=js"
import style0 from "./productItem.vue?vue&type=style&index=0&id=72bf0def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf0def",
  null
  
)

export default component.exports